import { SharedService } from './shared.service';
import { UploadFileDataService } from './upload-file-data/upload-file-data.service';

export const services = [
  UploadFileDataService,
  SharedService,
];

export * from './upload-file-data/upload-file-data.service';
